import type { AddOn } from './add-on';
import type { AddOnsVO } from './add-ons';
import { ADD_ON_IDS, SMS_MARKET_ADDON_ID_PREFIX } from './constants';
import { getStartingPriceFromAddOn, hasPriceTiers } from './get-addon-starting-price';

const isSmsMarketAddOnId = (addOnId: string): boolean => addOnId.startsWith(SMS_MARKET_ADDON_ID_PREFIX);

const findSmsAddOn = (addOns: AddOnsVO): AddOn | undefined => {
  const addOnList = addOns.getAddOns();
  const preferredAddOn = addOnList.find((addOn) => addOn.getId() === ADD_ON_IDS.SMS);

  if (hasPriceTiers(preferredAddOn)) {
    return preferredAddOn;
  }

  return addOnList.find((addOn) => isSmsMarketAddOnId(addOn.getId()) && hasPriceTiers(addOn));
};

/**
 * Resolves SMS "starting at" price from a geo-based getAddOns response (lite/bronze-plan anchor).
 * Primary: match `CTCT-SMS-ADDON` and read the lowest-tier starting price.
 * Fallback: first other SMS market addon in the response (`CTCT-SMS-ADDON*`) when geo returns
 * a market-specific id instead of the canonical id.
 * Returns null only when addOns is null/undefined (loading/error) or no SMS addon with tiers exists.
 */
export function getSmsStartingPriceFromAddOns(addOns: AddOnsVO | undefined | null): number | null {
  if (!addOns) {
    return null;
  }

  const smsAddOn = findSmsAddOn(addOns);

  if (!smsAddOn) {
    return null;
  }

  const startingPrice = getStartingPriceFromAddOn(smsAddOn);

  return startingPrice > 0 ? startingPrice : null;
}
